import React, { useCallback } from 'react';

interface Props {
  color?: string;
}

export const EyeIcon: React.FC<Props> = ({ color }) => {
  const renderColor = useCallback(() => {
    return color || '#000';
  }, [color]);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="13" fill="none" viewBox="0 0 20 13">
      <path
        fill={renderColor()}
        fillRule="evenodd"
        d="M13.86 6.838v.012a3.861 3.861 0 01-7.72 0v-.016-.01a3.861 3.861 0 017.72 0v.014zm-1.93 0a1.93 1.93 0 01-3.86-.002 1.93 1.93 0 013.86.003z"
        clipRule="evenodd"
      ></path>
      <path
        fill={renderColor()}
        fillRule="evenodd"
        d="M19.997 6.837a.975.975 0 01-.104.519c-.698 1.361-2.237 2.739-3.98 3.761-1.758 1.033-3.897 1.807-5.913 1.807h-.003c-2.016 0-4.153-.774-5.91-1.807-1.743-1.022-3.282-2.4-3.98-3.761a.961.961 0 01-.104-.519.965.965 0 01.104-.518c.698-1.362 2.237-2.74 3.98-3.762C5.844 1.524 7.983.75 10 .75h.003c2.016 0 4.153.775 5.91 1.807 1.743 1.023 3.282 2.4 3.98 3.762a.961.961 0 01.104.518zm-2.037 0c-.561.831-1.64 1.803-3.024 2.616-1.573.924-3.373 1.54-4.936 1.54-1.563 0-3.362-.616-4.936-1.54C3.68 8.64 2.6 7.668 2.04 6.837c.561-.831 1.64-1.803 3.024-2.615C6.637 3.298 8.437 2.68 10 2.68c1.563 0 3.363.618 4.936 1.542 1.384.812 2.463 1.784 3.024 2.615z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
